import { Box, Heading, Image, Text, Stack } from '@chakra-ui/react';

interface TabContentProps {
  title: string;
  image?: string;
}

const TabContent = ({ title, image }: TabContentProps) => {
  return (
    <Stack overflow="hidden" py={4}>
      <Heading as="h3" fontSize={{ base: 'lg', md: '3xl' }} fontWeight="medium" color="#4b5465">
        {title}
      </Heading>
      {image && <Image src={image} alt={title} mx="auto" />}
    </Stack>
  );
};

export default TabContent;
